import ReactHotToast from 'react-hot-toast';
import createToast from './createToast';

export default {
  chat: createToast('chat'),
  info: createToast('info'),
  warning: createToast('warning'),
  danger: createToast('danger'),
  success: createToast('success'),
  dismiss: (id) => ReactHotToast.dismiss(id),
  remove: (id) => ReactHotToast.remove(id),
};
